/* Rune — Custom Cart Drawer (simple, fixed)
   - Product images render
   - Checkout goes to /checkout
   - View cart goes to full cart page
   - Clicking the header bag icon NOW goes to the full cart page (no drawer)
*/

(function () {
  const drawer     = document.getElementById('runeCartDrawer');
  if (!drawer) return;

  const overlay    = drawer.querySelector('[data-rune-overlay]');
  const btnClose   = drawer.querySelector('[data-rune-close]');
  const itemsBox   = document.getElementById('runeCartItems');
  const subtotalEl = document.getElementById('runeCartSubtotal');
  const tpl        = document.getElementById('runeCartTpl');

  // open/close
  function openDrawer(){ drawer.setAttribute('aria-hidden','false'); }
  function closeDrawer(){ drawer.setAttribute('aria-hidden','true'); }
  overlay && overlay.addEventListener('click', closeDrawer);
  btnClose && btnClose.addEventListener('click', closeDrawer);
  document.addEventListener('keydown', e => { if (e.key === 'Escape') closeDrawer(); });

  // money
  function money(cents){
    try {
      if (window.Shopify && typeof Shopify.formatMoney === 'function') {
        const fmt = Shopify.money_format || '${{amount}}';
        return Shopify.formatMoney(cents || 0, fmt);
      }
    } catch(_){}
    return ( (cents||0)/100 ).toLocaleString(undefined,{style:'currency',currency:(Shopify?.currency?.active)||'USD'});
  }

  // choose best image url
  function bestImageUrl(item){
    const raw = (item.featured_image && (item.featured_image.url || item.featured_image.src)) || item.image || '';
    if (!raw) return '';
    if (/_\d+x\./.test(raw)) return raw;
    return raw.replace(/(\.(?:jpe?g|png|webp))(?:\?.*)?$/i, '_200x$1');
  }

  // cart api
  async function fetchCart(){
    const res = await fetch('/cart.js',{headers:{Accept:'application/json'}});
    return res.json();
  }
  async function change(key, qty){
    await fetch('/cart/change.js', {
      method:'POST',
      headers:{'Content-Type':'application/json',Accept:'application/json'},
      body: JSON.stringify({ id: key, quantity: Math.max(0, Number(qty)||0) })
    });
    const cart = await fetchCart();
    draw(cart);
  }

  // render
  function renderItem(item){
    const node = tpl.content.firstElementChild.cloneNode(true);
    node.dataset.key = item.key;

    const link  = node.querySelector('.runeItem__imgLink');
    const img   = node.querySelector('.runeItem__img');
    const title = node.querySelector('.runeItem__title');
    const variant= node.querySelector('.runeItem__variant');
    const price = node.querySelector('.runeItem__price');
    const qtyIn = node.querySelector('.runeQty__input');

    if (link)  link.href  = item.url;
    if (title){ title.textContent = item.product_title || item.title || ''; title.href = item.url; }
    if (variant) variant.textContent = item.variant_title || '';

    const src = bestImageUrl(item);
    if (img){
      img.src = src || 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///ywAAAAAAQABAAACAUwAOw==';
      img.alt = item.title || '';
    }
    if (price) price.textContent = money(item.final_line_price || 0);
    if (qtyIn) qtyIn.value = item.quantity;

    return node;
  }

  function draw(cart){
    itemsBox.innerHTML = '';
    (cart.items || []).forEach(it => itemsBox.appendChild(renderItem(it)));
    subtotalEl.textContent = money(cart.total_price || 0);
  }

  // qty +/− / remove (delegation)
  itemsBox.addEventListener('click', (e)=>{
    const row = e.target.closest('[data-key]');
    if (!row) return;
    const key = row.dataset.key;

    if (e.target.closest('.runeItem__remove')) {
      change(key, 0);
      return;
    }
    const deltaBtn = e.target.closest('.runeQty__btn');
    if (deltaBtn) {
      const delta = Number(deltaBtn.dataset.delta || 0);
      const input = row.querySelector('.runeQty__input');
      const next  = Math.max(0, Number(input.value||0) + delta);
      change(key, next);
    }
  });
  itemsBox.addEventListener('change', (e)=>{
    const input = e.target.closest('.runeQty__input');
    if (!input) return;
    const row = input.closest('[data-key]');
    change(row.dataset.key, input.value);
  });

  // open after add-to-cart (keep drawer behavior only after Add)
  document.addEventListener('submit', (e)=>{
    const form = e.target;
    if (!form.matches('form[action*="/cart/add"]')) return;
    e.preventDefault();
    (async ()=>{
      try{
        const fd = new FormData(form);
        await fetch('/cart/add.js',{method:'POST',headers:{Accept:'application/json'},body:fd});
        const cart = await fetchCart();
        draw(cart);
        openDrawer();
      }catch(_){
        location.href = '/cart';
      }
    })();
  });

  // IMPORTANT: we DO NOT hijack the header bag icon anymore.
  // So clicking the bag icon will follow its link to the full cart page.

})();

/* Rune — Custom Cart Drawer (simple, fixed)
   - Product images render
   - Checkout goes to /checkout
   - View cart goes to full cart page
   - Clicking the header bag icon NOW goes to the full cart page (no drawer)
*/

(function () {
  const drawer     = document.getElementById('runeCartDrawer');
  if (!drawer) return;

  const overlay    = drawer.querySelector('[data-rune-overlay]');
  const btnClose   = drawer.querySelector('[data-rune-close]');
  const itemsBox   = document.getElementById('runeCartItems');
  const subtotalEl = document.getElementById('runeCartSubtotal');
  const tpl        = document.getElementById('runeCartTpl');

  // [FREE-SHIP] settings + elements
  const FREE_SHIP_THRESHOLD = 6000; // $60.00 in cents
  const freeTextEl = document.getElementById('runeFreeShipText');
  const freeFillEl = document.getElementById('runeFreeShipFill');

  // open/close
  function openDrawer(){ drawer.setAttribute('aria-hidden','false'); }
  function closeDrawer(){ drawer.setAttribute('aria-hidden','true'); }
  overlay && overlay.addEventListener('click', closeDrawer);
  btnClose && btnClose.addEventListener('click', closeDrawer);
  document.addEventListener('keydown', e => { if (e.key === 'Escape') closeDrawer(); });

  // money
  function money(cents){
    try {
      if (window.Shopify && typeof Shopify.formatMoney === 'function') {
        const fmt = Shopify.money_format || '${{amount}}';
        return Shopify.formatMoney(cents || 0, fmt);
      }
    } catch(_){}
    return ( (cents||0)/100 ).toLocaleString(undefined,{style:'currency',currency:(Shopify?.currency?.active)||'USD'});
  }

  // choose best image url
  function bestImageUrl(item){
    const raw = (item.featured_image && (item.featured_image.url || item.featured_image.src)) || item.image || '';
    if (!raw) return '';
    if (/_\d+x\./.test(raw)) return raw;
    return raw.replace(/(\.(?:jpe?g|png|webp))(?:\?.*)?$/i, '_200x$1');
  }

  // cart api
  async function fetchCart(){
    const res = await fetch('/cart.js',{headers:{Accept:'application/json'}});
    return res.json();
  }
  async function change(key, qty){
    await fetch('/cart/change.js', {
      method:'POST',
      headers:{'Content-Type':'application/json',Accept:'application/json'},
      body: JSON.stringify({ id: key, quantity: Math.max(0, Number(qty)||0) })
    });
    const cart = await fetchCart();
    draw(cart);
  }

  // render
  function renderItem(item){
    const node = tpl.content.firstElementChild.cloneNode(true);
    node.dataset.key = item.key;

    const link  = node.querySelector('.runeItem__imgLink');
    const img   = node.querySelector('.runeItem__img');
    const title = node.querySelector('.runeItem__title');
    const variant= node.querySelector('.runeItem__variant');
    const price = node.querySelector('.runeItem__price');
    const qtyIn = node.querySelector('.runeQty__input');

    if (link)  link.href  = item.url;
    if (title){ title.textContent = item.product_title || item.title || ''; title.href = item.url; }
    if (variant) variant.textContent = item.variant_title || '';

    const src = bestImageUrl(item);
    if (img){
      img.src = src || 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///ywAAAAAAQABAAACAUwAOw==';
      img.alt = item.title || '';
    }
    if (price) price.textContent = money(item.final_line_price || 0);
    if (qtyIn) qtyIn.value = item.quantity;

    return node;
  }

  // [FREE-SHIP] update the progress text + bar
  function updateFreeShip(totalCents){
    if (!freeTextEl || !freeFillEl) return; // if markup not present, skip
    const total = Number(totalCents) || 0;
    const left  = Math.max(FREE_SHIP_THRESHOLD - total, 0);
    const pct   = Math.min(100, Math.max(0, Math.round((total / FREE_SHIP_THRESHOLD) * 100)));
    freeFillEl.style.width = pct + '%';
    freeTextEl.textContent = left > 0
      ? `You're ${money(left)} away from free shipping`
      : `🎉 You unlocked free shipping!`;
  }

  function draw(cart){
    itemsBox.innerHTML = '';
    (cart.items || []).forEach(it => itemsBox.appendChild(renderItem(it)));
    subtotalEl.textContent = money(cart.total_price || 0);

    // [FREE-SHIP] keep the bar in sync with totals
    updateFreeShip(cart.total_price || 0);
  }

  // qty +/− / remove (delegation)
  itemsBox.addEventListener('click', (e)=>{
    const row = e.target.closest('[data-key]');
    if (!row) return;
    const key = row.dataset.key;

    if (e.target.closest('.runeItem__remove')) {
      change(key, 0);
      return;
    }
    const deltaBtn = e.target.closest('.runeQty__btn');
    if (deltaBtn) {
      const delta = Number(deltaBtn.dataset.delta || 0);
      const input = row.querySelector('.runeQty__input');
      const next  = Math.max(0, Number(input.value||0) + delta);
      change(key, next);
    }
  });
  itemsBox.addEventListener('change', (e)=>{
    const input = e.target.closest('.runeQty__input');
    if (!input) return;
    const row = input.closest('[data-key]');
    change(row.dataset.key, input.value);
  });


})();
/* Tag any cart-page upsell block so CSS can style it reliably */
document.addEventListener('DOMContentLoaded', function () {
  // Look for common complementary/upsell wrappers inside cart line items
  const upsells = document.querySelectorAll(
    '.cart-items .cart-item .complementary-products, ' +
    '.cart-items .cart-item [class*="complementary"], ' +
    '.cart-items .cart-item [data-upsell], ' +
    '.cart-items .cart-item .rc__upsell, ' +          // catches some apps
    '.cart-items .cart-item .rc-widget-injected'
  );
  upsells.forEach(el => el.classList.add('rjc-upsell'));
});


